<div>
    @if (form) {
        <form (ngSubmit)="onSubmit()" [formGroup]="form">
            @for (question of questions; track question) {
                <div>
                    <vp-question
                        [question]="question"
                        (questionTrigger)="questionTrigger.emit($event)"
                        [highlights]="highlights"
                        [form]="form"
                    ></vp-question>
                </div>
            }
            <div class="flex justify-end items-center">
                <div>
                    <ng-content select="[bottomRightContent]"></ng-content>
                </div>
                <div>
                    @if (!customSubmitEnabled) {
                        <button
                            type="submit"
                            mat-flat-button
                            class="ca-button ca-button-m flex ms-auto"
                            [caConfirm]="{
                                titleElement: confirmTitleElement,
                                contentElement: confirmContentElement,
                                cancelBtn: 'COMMON.BUTTONS.NO' | translate,
                                confirmBtn: 'COMMON.BUTTONS.YES' | translate,
                                disabled: !form.valid || !isValueDifferentThanCache || !onSubmitCacheConfig?.updateOnConfim
                            }"
                            (confirm)="updateCacheAndSubmit()"
                            (cancel)="restoreValueFromCache()"
                        >
                            <ng-container *ngTemplateOutlet="buttonTextElement"></ng-container>
                        </button>
                    } @else {
                        <button
                            type="button"
                            mat-flat-button
                            class="ca-button ca-button-m flex ms-auto"
                            [caConfirm]="customConfirm"
                            (confirm)="onSubmit()"
                        >
                            <ng-container *ngTemplateOutlet="buttonTextElement"></ng-container>
                        </button>
                    }
                </div>
            </div>
        </form>
    }
</div>

<ng-template #buttonTextElement>
    <ng-content select="[buttonText]"></ng-content>
</ng-template>

<ng-template #confirmTitleElement>
    <h4>{{ 'CONFIRM.CALCULATION_PROGRESS.TITLE' | translate }}</h4>
</ng-template>

<ng-template #confirmContentElement>
    {{ 'CONFIRM.CALCULATION_PROGRESS.CONTENT' | translate }}
</ng-template>
